// extracted by mini-css-extract-plugin
export default {"switch":"TextSwitcher_switch__ERqYa","selected":"TextSwitcher_selected__Hl6pG","title":"TextSwitcher_title__VWCG6"};